import { GenericObject } from "utility/misc";

export default function redirectToSplunkWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/splunk_webhook/connect");
}
